import React from 'react';
import Image from 'next/image';

const BrandsSection = () => {
  const brands = [
    {
      id: 1,
      name: "Brand 1",
      logo: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/gsbb18.svg"
    },
    {
      id: 2,
      name: "Brand 2", 
      logo: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/gsbb17.svg"
    },
    {
      id: 3,
      name: "Brand 3",
      logo: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/gsbb3.png"
    },
    {
      id: 4,
      name: "Brand 4",
      logo: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/gsbb4.png"
    },
    {
      id: 5,
      name: "Brand 5",
      logo: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/gsbb5.png"
    },
    {
      id: 6,
      name: "Brand 6",
      logo: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/gsbb6.png"
    },
    {
      id: 7,
      name: "Brand 7",
      logo: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/gsbb7.png"
    },
    {
      id: 8,
      name: "Brand 8",
      logo: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/gsbb8.png"
    },
    {
      id: 9,
      name: "Brand 9",
      logo: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/gsbb9.png"
    },
    {
      id: 10,
      name: "Brand 10",
      logo: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/gsbb10.png"
    },
    {
      id: 11,
      name: "Brand 11",
      logo: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/gsbb11.png"
    },
    {
      id: 12,
      name: "Brand 12",
      logo: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/gsbb12.png"
    },
   
    {
      id: 13,
      name: "Brand 14",
      logo: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/gsbb14.png"
    },
    {
      id: 14,
      name: "Brand 15",
      logo: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/gsbb15.png"
    },
       {
      id: 14,
      name: "Brand 15",
      logo: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/gsbb2.png"
    },
          {
      id: 14,
      name: "Brand 15",
      logo: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/gsbb1.png"
    }
  ];

  return (
    <div className="w-full py-16 bg-[#fcf8ef]">
      <div className="w-[90%] md:w-[80%] mx-auto">
        {/* Section Title */}
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-[36px] font-medium text-gray-900 leading-tight">
            Our Clients
          </h2>
        </div>

        {/* Brands Grid */}
        <div className="grid grid-cols-3 md:grid-cols-4 gap-4 md:gap-6">
          {brands.map((brand) => (
            <div
              key={brand.id}
              className="  flex items-center rounded-2xl  justify-center  duration-300"
            >
              <div className="relative w-[210px] h-16 md:h-[107px]">
                <Image
                  src={brand.logo}
                  alt={brand.name}
                  fill
                  className="object-contain rounded-2xl"
                  sizes="(max-width: 768px) 104px, 157px"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BrandsSection;